import React, { useState } from "react";
import { Modal,Box,Typography,IconButton,Chip, Stack,Divider,Paper,useMediaQuery,Grid,Tabs,Tab} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import VideocamIcon from "@mui/icons-material/Videocam";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ImageIcon from "@mui/icons-material/Image";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";

// Import location-based images and videos
import Solitaire20entally_image1 from "../images/residential/Solitaire20entally_image1.jpeg";
import Solitaire20entally_image2 from "../images/residential/Solitaire20entally_image2.jpeg";
import Solitaire20entally_video from "../images/residential/Solitaire20entally_video.mp4";
import Ruby_vedio from "../images/residential/Ruby_vedio.mp4";
import Ambikapur_image1 from "../images/residential/Ambikapur_image1.jpeg";
import Ambikapur_image2 from "../images/residential/Ambikapur_image2.jpeg";
import Ambikapur_image3 from "../images/residential/Ambikapur_image3.jpeg";
import Ambikapur_image4 from "../images/residential/Ambikapur_image4.jpeg";
import Ambikapur_image5 from "../images/residential/Ambikapur_image5.jpeg";
import Ambikapur_vedio from "../images/residential/Ambikapur_vedio.mp4";
import Ambikapur_vedio1 from "../images/residential/Ambikapur_vedio1.mp4";

// Complete location data mapping with all images and videos
const locationDataMap = {
  Solitaire: {
    address: "Solitaire, Kolkata, West Bengal 700001",
    city: "Kolkata",
    state: "West Bengal",
    country: "India",
    images: [Solitaire20entally_image1, Solitaire20entally_image2],
    videos: [Solitaire20entally_video],
    location: "Solitaire",
    imageCount: 2,
    videoCount: 1,
    color: "#FF6B35",
  },
  Ruby: {
    address: "Ruby, Kolkata, West Bengal 700001",
    city: "Kolkata",
    state: "West Bengal",
    country: "India",
    images: [Solitaire20entally_image1, Solitaire20entally_image2],
    videos: [Ruby_vedio],
    location: "Ruby",
    imageCount: 2,
    videoCount: 1,
    color: "#E91E63",
  },
  Ambikapur: {
    address: "Ambikapur, Kolkata, West Bengal 700001",
    city: "Kolkata",
    state: "West Bengal",
    country: "India",
    images: [
      Ambikapur_image1,
      Ambikapur_image2,
      Ambikapur_image3,
      Ambikapur_image4,
      Ambikapur_image5,
    ],
    videos: [Ambikapur_vedio, Ambikapur_vedio1],
    location: "Ambikapur",
    imageCount: 5,
    videoCount: 2,
    color: "#4CAF50",
  },
};

// Get all location keys
const locationKeys = Object.keys(locationDataMap);

const ServiceDetailsPopup = ({ open, onClose, service }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedLocation, setSelectedLocation] = useState(
    locationKeys[0] || "Solitaire",
  );
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [tabValue, setTabValue] = useState(0);

  if (!service) return null;

  // Get current location data
  const locationData = locationDataMap[selectedLocation];
  const serviceImages = locationData.images || [];
  const serviceVideos = locationData.videos || [];
  const locationInfo = {
    address: locationData.address,
    city: locationData.city,
    state: locationData.state,
    country: locationData.country,
  };

  const currentVideoUrl =
    serviceVideos.length > 0
      ? serviceVideos[currentVideoIndex % serviceVideos.length]
      : null;

  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === serviceImages.length - 1 ? 0 : prev + 1,
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? serviceImages.length - 1 : prev - 1,
    );
  };

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
    setShowVideo(false);
  };

  const handlePlayVideo = () => {
    setShowVideo(true);
    if (serviceVideos.length > 1) {
      setCurrentVideoIndex((prev) => (prev + 1) % serviceVideos.length);
    }
  };

  const handleLocationChange = (location) => {
    setSelectedLocation(location);
    setCurrentImageIndex(0);
    setShowVideo(false);
    setCurrentVideoIndex(0);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setShowVideo(false);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: { xs: "95%", sm: "90%", md: "85%", lg: "80%" },
          maxWidth: "1200px",
          maxHeight: "90vh",
          backgroundColor: "#1a1a1a",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 24px 64px rgba(0, 0, 0, 0.6)",
          display: "flex",
          flexDirection: "column",
          height: { xs: "auto", md: "90vh" },
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            zIndex: 10,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            },
            width: 40,
            height: 40,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Header */}
        <Box
          sx={{
            padding: { xs: 2, sm: 3 },
            borderBottom: "1px solid rgba(255,255,255,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pr: { xs: 6, sm: 7 },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: 700,
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            {service.title || "Project Gallery"}
          </Typography>
          <Chip
            label={`${locationKeys.length} Locations`}
            size="small"
            sx={{
              backgroundColor: "rgba(255, 107, 53, 0.2)",
              color: "#FF6B35",
              fontWeight: 600,
            }}
          />
        </Box>

        {/* Main Content - Scrollable */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            padding: { xs: 2, sm: 3, md: 4 },
            "&::-webkit-scrollbar": {
              width: 6,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#FF6B35",
              borderRadius: "4px",
            },
          }}
        >
          {/* Location Tabs */}
          <Tabs
            value={selectedLocation}
            onChange={(e, val) => handleLocationChange(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              mb: 3,
              borderBottom: 1,
              borderColor: "divider",
              "& .MuiTab-root": {
                color: "rgba(255,255,255,0.7)",
                fontWeight: 600,
                "&.Mui-selected": {
                  color: "#FF6B35",
                },
              },
            }}
          >
            {locationKeys.map((key) => (
              <Tab
                key={key}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <LocationOnIcon sx={{ fontSize: 16 }} />
                    {key}
                    <Chip
                      label={`${locationDataMap[key].imageCount} 📷`}
                      size="small"
                      sx={{
                        ml: 1,
                        backgroundColor: "rgba(255,255,255,0.1)",
                        color: "rgba(255,255,255,0.7)",
                        fontSize: "0.7rem",
                        height: 20,
                      }}
                    />
                  </Box>
                }
                value={key}
              />
            ))}
          </Tabs>

          {/* Media Tabs - Images/Video */}
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              mb: 2,
              "& .MuiTab-root": {
                color: "rgba(255,255,255,0.7)",
                "&.Mui-selected": {
                  color: "#FF6B35",
                },
              },
            }}
          >
            <Tab
              icon={<ImageIcon />}
              label={`Images (${serviceImages.length})`}
              iconPosition="start"
            />
            <Tab
              icon={<VideoLibraryIcon />}
              label={`Videos (${serviceVideos.length})`}
              iconPosition="start"
            />
          </Tabs>

          {/* Image Gallery */}
          {tabValue === 0 && (
            <Box>
              {/* Main Image Display */}
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: { xs: "300px", sm: "400px", md: "500px" },
                  backgroundColor: "#0a0a0a",
                  borderRadius: "12px",
                  overflow: "hidden",
                  marginBottom: 2,
                }}
              >
                {serviceImages.length > 0 ? (
                  <>
                    <img
                      src={serviceImages[currentImageIndex]}
                      alt={`${locationInfo.city} - ${selectedLocation} Project ${currentImageIndex + 1}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        transition: "all 0.3s ease",
                      }}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/800x600/FF6B35/FFFFFF?text=Image+Not+Found";
                      }}
                    />

                    {/* Navigation Arrows */}
                    {serviceImages.length > 1 && (
                      <>
                        <IconButton
                          onClick={handlePrevImage}
                          sx={{
                            position: "absolute",
                            left: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "rgba(255, 255, 255, 0.2)",
                            },
                            width: 40,
                            height: 40,
                          }}
                        >
                          <ArrowBackIosNewIcon />
                        </IconButton>

                        <IconButton
                          onClick={handleNextImage}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            color: "white",
                            "&:hover": {
                              backgroundColor: "rgba(255, 255, 255, 0.2)",
                            },
                            width: 40,
                            height: 40,
                          }}
                        >
                          <ArrowForwardIosIcon />
                        </IconButton>
                      </>
                    )}

                    {/* Image Counter */}
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 12,
                        right: 12,
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        color: "white",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                      }}
                    >
                      {currentImageIndex + 1} / {serviceImages.length}
                    </Box>

                    {/* Location Badge */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 12,
                        left: 12,
                        backgroundColor: locationData.color || "#FF6B35",
                        color: "white",
                        padding: "6px 16px",
                        borderRadius: "20px",
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <LocationOnIcon sx={{ fontSize: 16 }} />
                      {selectedLocation}
                    </Box>
                  </>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      color: "rgba(255,255,255,0.5)",
                    }}
                  >
                    <Typography>
                      No images available for this location
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Thumbnails */}
              {serviceImages.length > 1 && (
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    overflowX: "auto",
                    padding: "4px 0",
                    "&::-webkit-scrollbar": {
                      height: 4,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#FF6B35",
                      borderRadius: "4px",
                    },
                  }}
                >
                  {serviceImages.map((img, index) => (
                    <Box
                      key={index}
                      onClick={() => handleThumbnailClick(index)}
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: "8px",
                        overflow: "hidden",
                        cursor: "pointer",
                        border:
                          currentImageIndex === index
                            ? `3px solid ${locationData.color || "#FF6B35"}`
                            : "2px solid transparent",
                        transition: "all 0.3s ease",
                        flexShrink: 0,
                        "&:hover": {
                          transform: "scale(1.05)",
                          border: `2px solid ${locationData.color || "#FF6B35"}`,
                        },
                      }}
                    >
                      <img
                        src={img}
                        alt={`Thumbnail ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          e.target.src =
                            "https://via.placeholder.com/80x80/FF6B35/FFFFFF?text=?";
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          )}

          {/* Video Gallery */}
          {tabValue === 1 && (
            <Box>
              {serviceVideos.length > 0 ? (
                <Box>
                  {/* Video Player */}
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: { xs: "300px", sm: "400px", md: "500px" },
                      backgroundColor: "#000",
                      borderRadius: "12px",
                      overflow: "hidden",
                      marginBottom: 2,
                    }}
                  >
                    <video
                      controls
                      autoPlay
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    >
                      <source src={currentVideoUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>

                    {/* Location Badge */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 12,
                        left: 12,
                        backgroundColor: locationData.color || "#FF6B35",
                        color: "white",
                        padding: "6px 16px",
                        borderRadius: "20px",
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <LocationOnIcon sx={{ fontSize: 16 }} />
                      {selectedLocation}
                    </Box>

                    {/* Video Counter */}
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: 12,
                        right: 12,
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        color: "white",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                      }}
                    >
                      Video {currentVideoIndex + 1} / {serviceVideos.length}
                    </Box>
                  </Box>

                  {/* Video Thumbnails */}
                  {serviceVideos.length > 1 && (
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        overflowX: "auto",
                        padding: "4px 0",
                        "&::-webkit-scrollbar": {
                          height: 4,
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#FF6B35",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      {serviceVideos.map((video, index) => (
                        <Box
                          key={index}
                          onClick={() => {
                            setCurrentVideoIndex(index);
                            setShowVideo(true);
                          }}
                          sx={{
                            width: 160,
                            height: 100,
                            borderRadius: "8px",
                            overflow: "hidden",
                            cursor: "pointer",
                            border:
                              currentVideoIndex === index
                                ? `3px solid ${locationData.color || "#FF6B35"}`
                                : "2px solid transparent",
                            transition: "all 0.3s ease",
                            flexShrink: 0,
                            position: "relative",
                            backgroundColor: "#000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:hover": {
                              transform: "scale(1.05)",
                              border: `2px solid ${locationData.color || "#FF6B35"}`,
                            },
                          }}
                        >
                          <PlayCircleIcon
                            sx={{
                              fontSize: 48,
                              color: "rgba(255,255,255,0.8)",
                              position: "absolute",
                            }}
                          />
                          <Typography
                            variant="caption"
                            sx={{
                              position: "absolute",
                              bottom: 4,
                              right: 8,
                              color: "white",
                              backgroundColor: "rgba(0,0,0,0.6)",
                              padding: "2px 8px",
                              borderRadius: "4px",
                              fontSize: "0.6rem",
                            }}
                          >
                            Video {index + 1}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "300px",
                    color: "rgba(255,255,255,0.5)",
                  }}
                >
                  <Typography>No videos available for this location</Typography>
                </Box>
              )}
            </Box>
          )}

          {/* Location Info Section */}
          <Paper
            sx={{
              mt: 3,
              padding: 2,
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              borderRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.08)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <LocationOnIcon sx={{ color: "#FF6B35", fontSize: 20 }} />
              <Typography
                variant="subtitle2"
                sx={{ color: "#FF6B35", fontWeight: 600 }}
              >
                {selectedLocation} Location Details
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "rgba(255, 255, 255, 0.9)", mb: 0.5 }}
            >
              {locationInfo.address}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "rgba(255, 255, 255, 0.5)" }}
            >
              {locationInfo.city}, {locationInfo.state}, {locationInfo.country}
            </Typography>

            <Box sx={{ mt: 1, display: "flex", gap: 2 }}>
              <Typography
                variant="caption"
                sx={{ color: "rgba(255,255,255,0.5)" }}
              >
                📷 {locationData.imageCount} Images
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "rgba(255,255,255,0.5)" }}
              >
                🎬 {locationData.videoCount} Videos
              </Typography>
            </Box>

            <Box sx={{ mt: 1 }}>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationInfo.address)}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#FF6B35",
                  textDecoration: "none",
                  fontSize: "0.85rem",
                  fontWeight: 600,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                View on Google Maps →
              </a>
            </Box>
          </Paper>

          {/* Action Button */}
          <Box sx={{ mt: 3 }}>
            <button
              onClick={() => {
                onClose();
              }}
              style={{
                width: "100%",
                padding: "14px",
                backgroundColor: "#FF6B35",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "1rem",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#e55a2b";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#FF6B35";
                e.target.style.transform = "translateY(0)";
              }}
            >
              Get Free Consultation
            </button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ServiceDetailsPopup;
